export function capitalizeFirstLetter(text: string): string {
  if (text?.length) {
    return text.charAt(0).toUpperCase() + text.slice(1);
  } else {
    return "";
  }
}
